<template>
    <div class="solutionContainer">
        <div class="solutionSection">
            <picture class="solutionImg">
                <source :srcset="require('@/assets/solutions/reponse-rapide-service-client.webp')" type='image/webp' />
                <img :src="require('@/assets/solutions/reponse-rapide-service-client.jpg')" alt="icône camion de transport en livraison" loading="lazy" />
            </picture>
            <div class="solutionContent">
                <h3 class="solutionH3">{{ $t('customerService.title') }}</h3>
                <h4 class="solutionsIntro">{{ $t('customerService.subtitle') }}</h4>
                <div class="solutionText"> 
                    {{ $t('customerService.paragraph1') }}
                </div>
                <div class="isExpanded">
                    <div class="expandedSection">
                        <div class="paraf">
                            <div class="iconCheck">
                                <img src="../assets/icon_check.png" alt="Icône check" loading='lazy' />
                            </div>
                            <div class="expandedTxt expandedP1">
                                {{ $t('customerService.paragraph2') }}
                            </div>
                        </div>
                        <div class="paraf">
                            <div class="iconCheck">
                                <img src="../assets/icon_check.png" alt="Icône check" loading='lazy' />
                            </div>
                            <div class="expandedTxt expandedP2">
                                {{ $t('customerService.paragraph3') }}
                            </div>
                        </div>
                         <div class="paraf">
                            <div class="iconCheck">
                                <img src="../assets/icon_check.png" alt="Icône check" loading='lazy' />
                            </div>
                            <div class="expandedTxt expandedP2">
                                {{ $t('customerService.paragraph4') }}
                            </div>
                        </div>
                        <div class="customerOpinion">
                            <div class="optinionCard pinkCard">
                                <div class="starsImg">
                                    <img src="../assets/icon_stars.png" alt="Cinq étoiles" loading='lazy' />
                                </div>
                                <div class="opinionTxt">{{ $t('customerService.opinion1') }}</div>
                                <div class="opinionDetails">
                                    <!-- <picture class="opinionImg">
                                        <source :srcset="require('@/assets/solutions/equipe-service-client-GMA-logistics.webp')" type='image/webp' />
                                        <img :src="require('@/assets/solutions/equipe-service-client-GMA-logistics.jpg')" alt="Avis client positif sur le service client de GMA logistics" loading="lazy" />
                                    </picture> -->
                                    <div class="opinionNameAndCountry">
                                        <div>Thibault Merlange</div>
                                        <div>{{ $t('customerService.function1') }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="optinionCard pinkCard">
                                <div class="starsImg">
                                    <img src="../assets/icon_stars.png" alt="Cinq étoiles" loading="lazy" />
                                </div>
                                <div class="opinionTxt">{{ $t('customerService.opinion2') }}</div>
                                <div class="opinionDetails">
                                    <!-- <picture class="opinionImg">
                                        <source :srcset="require('@/assets/solutions/cariste-entrepot-manutention.webp')" type='image/webp' />
                                        <img :src="require('@/assets/solutions/cariste-entrepot-manutention.jpg')" alt="Client qui donne son avis satisfait sur l'efficacité du service client" loading="lazy" />
                                    </picture> -->
                                    <div class="opinionNameAndCountry">
                                        <div>Camille Ventrelle</div>
                                        <div>{{ $t('customerService.function2') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.customerOpinion, .optinionCard, .opinionDetails, .opinionNameAndCountry {
    display: flex;
}
.optinionCard, .opinionNameAndCountry {
    flex-direction: column;
}
.optinionCard {
    flex: 1;
    padding: 10px;
    box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.07);
    border-radius: 30px;
}
.optinionCard + .optinionCard {
    margin-left: 10px;
}
.starsImg {
    width: 100px;
    height: auto;
}
.starsImg > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.solutionContainer {
    margin: 50px auto;
    padding: 0 30px;
    max-width: 1440px;
}
.customerOpinion {
    margin-top: 50px;
    margin-left: -30px;
}
.opinionDetails {
    font-size: 14px;
    font-weight: 600;
    margin-top: auto;
    padding-top: 20px;
}
.opinionTxt {
    margin-top: 15px;
    font-style: italic;
}
.opinionImg {
    width: 60px;
    height: 60px;
    border-radius: 50%;
}
.opinionImg > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}
.opinionNameAndCountry {
    /* margin-left: 30px; */
    align-self: center;
}
.solutionsSection {
    margin: 50px 0;
    padding: 0 30px;
}
.solutionImg {
    margin-left: 0;
    box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
}

@media screen and (min-width: 2000px ) {
    .solutionContainer {
        padding: 0;
    }
}

@media screen and (max-width: 750px ) {
        .customerOpinion {
            flex-direction: column;
            margin-left: 0;
        }
        .optinionCard + .optinionCard {
            margin-top: 20px;
        }
        .pinkCard {
            /* box-shadow: 32px 32px 32px 32px rgba(0, 0, 0, 0.07); */
            border: solid 1px #e91e63;
        }
    }
</style>